import { render } from "./ViewMarchand.vue?vue&type=template&id=58f2e306&ts=true"
import script from "./ViewMarchand.vue?vue&type=script&lang=ts"
export * from "./ViewMarchand.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__